import React, { useState } from 'react'
import { useMutation } from 'react-apollo-hooks'
import styled from 'react-emotion'
import { language } from '../../../resources'
import getText from '../../strings'
import { ModalOverlay, ModalDialog } from '../../../styles'
import * as Mutations from '../../mutations'

const Container = styled('div')`
  display: flex;
`

const Name = styled('span')`
  margin-right: 12px;
`

const ConnectionWrapper = styled('div')``

const MembershipId = styled('span')`
  font-weight: bold;
  margin-right: 12px;
`

const ActionButton = styled('a')``

const Buttons = styled('div')`
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  button:first-child {
    width: 100%;
    margin-right: 10px;
  }
  button:last-child {
    width: 100%;
    margin-left: 10px;
  }
`

const Button = styled('button')`
  white-space: nowrap;
`

const Inputs = styled('div')``

const Label = styled('label')``

const Input = styled('input')`
  width: 100%;
`

const Error = styled('div')`
  margin-top: 12px;
`

export default ({ data, onSave }) => {
  const [connecting, setConnecting] = useState(false)
  const [disconnecting, setDisconnecting] = useState(false)
  const [error, setError] = useState(false)
  const [showConnectModal, setShowConnectModal] = useState(false)
  const [showDisconnectModal, setShowDisconnectModal] = useState(false)
  const [ssn, setSsn] = useState('')

  const connectPartner = useMutation(Mutations.connectCoopSEPartner)
  const removePartner = useMutation(Mutations.removePartner)

  const connect = () => {
    setConnecting(true)
    connectPartner({
      variables: {
        socialSecurityNumber: ssn,
      },
      update: (_, mutationResult) => {
        if (mutationResult.data.connectCoopSEPartner.success) {
          setConnecting(false)
          setError(false)
          setShowConnectModal(false)
          onSave()
        } else {
          console.log(mutationResult.data.connectCoopSEPartner.errorCode)
          setError(mutationResult.data.connectCoopSEPartner.errorCode)
          setConnecting(false)
        }
      },
    })
  }

  const disconnect = () => {
    setDisconnecting(true)
    removePartner({
      variables: {
        partnerId: 'COOPSE',
      },
      update: (_, mutationResult) => {
        if (mutationResult.data.removePartner) {
          setDisconnecting(false)
          setError('GENERAL_ERROR')
          setShowDisconnectModal(false)
          onSave()
        } else {
          setError(true)
          setDisconnecting(false)
        }
      },
    })
  }

  const handleConnect = () => {
    setShowConnectModal(true)
  }

  const handleDisconnect = () => {
    setShowDisconnectModal(true)
  }

  const handleSsnChange = (e) => {
    setSsn(e.target.value)
  }

  if (!data || language !== 'se') {
    return null
  }

  return (
    <Container>
      <Name>{getText('partners', 'coopse', 'title')}: </Name>
      {data.memberId && (
        <ConnectionWrapper>
          <MembershipId>{data.memberId}</MembershipId>
          <ActionButton onClick={handleDisconnect} href="javascript:void()">
            {getText('partners', 'coopse', 'disconnect')}
          </ActionButton>
        </ConnectionWrapper>
      )}
      {!data.memberId && (
        <ConnectionWrapper>
          <ActionButton onClick={handleConnect} href="javascript:void()">
            {getText('partners', 'coopse', 'connect')}
          </ActionButton>
        </ConnectionWrapper>
      )}

      {showConnectModal && (
        <ModalOverlay>
          <ModalDialog width={400}>
            <h3>{getText('partners', 'coopse', 'titleConnect')}</h3>
            <Inputs>
              <Label>{getText('partners', 'coopse', 'ssn')}:</Label>
              <Input type="text" placeholder="YYYYMMDDXXXX" onChange={handleSsnChange} />
            </Inputs>
            {error && <Error>{getText('partners', 'coopse', error)}</Error>}
            <Buttons>
              <Button onClick={() => connect()} className="btn btn-function" disabled={connecting}>
                {getText('partners', 'coopse', 'connect')}
              </Button>
              <Button onClick={() => setShowConnectModal(false) && setError(false)} className="btn ghost-blue" disabled={connecting}>
                {getText('partners', 'coopse', 'cancel')}
              </Button>
            </Buttons>
          </ModalDialog>
        </ModalOverlay>
      )}

      {showDisconnectModal && (
        <ModalOverlay>
          <ModalDialog width={400}>
            <h3>{getText('partners', 'coopse', 'titleDisconnect')}</h3>
            {error && <Error>{getText('partners', 'coopse', error)}</Error>}
            <Buttons>
              <Button onClick={() => disconnect()} className="btn btn-function" disabled={disconnecting}>
                {getText('partners', 'coopse', 'disconnect')}
              </Button>
              <Button onClick={() => setShowDisconnectModal(false) && setError(false)} className="btn ghost-blue" disabled={disconnecting}>
                {getText('partners', 'coopse', 'cancel')}
              </Button>
            </Buttons>
          </ModalDialog>
        </ModalOverlay>
      )}
    </Container>
  )
}
